import { createLightTheme } from '../../utils/createLightTheme';
import { brandWeb } from '../../global/brandColors';
import type { Theme } from '../../types';

export const webLightTheme: Theme = createLightTheme(brandWeb);
